import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { PrimaryButton, SecondaryButton } from "../common";
import {
  MOBILE_SHEET_FOOTER_BUTTON_GAP,
  mobileSheetCancelButtonSx,
  mobileSheetConfirmButtonSx,
} from "../common/mobileSheetFooterButtons";

interface IProps {
  onGoBackButtonClick: Function;
  onNextButtonClick: Function;
  loading?: boolean;
  goBackButtonText?: string;
  nextButtonText?: string;
  disabled?: boolean;
  disabledBackButton?: boolean;
  maxWidth?: boolean;
  direction?: "row" | "row-reverse" | "column" | "column-reverse";
}

/**
 * Par de botões "Avançar" e "Voltar".
 *
 * Mobile: linha lado a lado (Cancelar | Confirmar), padrão do sheet "Selecionar mês".
 * Desktop: PrimaryButton / SecondaryButton em row-reverse.
 */
export function FormButtonGroup({
  onGoBackButtonClick,
  onNextButtonClick,
  loading = false,
  goBackButtonText,
  nextButtonText,
  maxWidth,
  disabled = false,
  direction,
  disabledBackButton,
}: IProps) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobileLayout) {
    return (
      <Stack
        width="100%"
        direction={direction ?? "row"}
        spacing={MOBILE_SHEET_FOOTER_BUTTON_GAP}
        justifyContent="space-between"
      >
        {onGoBackButtonClick ? (
          <Button
            fullWidth
            variant="outlined"
            id="goBackButton"
            disabled={disabledBackButton}
            onClick={() => onGoBackButtonClick()}
            sx={mobileSheetCancelButtonSx}
          >
            {goBackButtonText || "Voltar"}
          </Button>
        ) : null}
        <LoadingButton
          fullWidth
          variant="contained"
          disableElevation
          loading={loading}
          disabled={disabled}
          onClick={() => onNextButtonClick()}
          sx={mobileSheetConfirmButtonSx}
        >
          {nextButtonText || "Avançar"}
        </LoadingButton>
      </Stack>
    );
  }

  return (
    <Stack
      width="100%"
      direction={direction ? direction : { xs: "column", md: "row-reverse" }}
      spacing={{ xs: 2, lg: 4 }}
      justifyContent="space-between"
    >
      <PrimaryButton
        width={maxWidth ? "220px" : "100% "}
        height="50px"
        loading={loading}
        onClick={() => onNextButtonClick()}
        disabled={disabled}
      >
        {nextButtonText || "Avançar"}
      </PrimaryButton>

      {onGoBackButtonClick && (
        <SecondaryButton
          width={maxWidth ? "220px" : "100% "}
          height="50px"
          onClick={() => onGoBackButtonClick()}
          id="goBackButton"
          disabled={disabledBackButton}
        >
          {goBackButtonText || "Voltar"}
        </SecondaryButton>
      )}
    </Stack>
  );
}
